import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, MonitorSmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const plan = {
  name: '📘 THE 100+ AI PROMPTS FOR ELECTRICAL ENGINEERS™',
  ideal: 'Electrical Engineers, Electrical Technicians, Project Engineers, Maintenance Professionals, and Engineering Consultants who want to organize their AI-assisted work and structure recurring technical tasks.',
  was: '$174',
  now: '27',
  features: ['Full 6-Volume Engineering AI System', '100+ Ready-to-Adapt Engineering AI Prompts', 'Compatibility with Supported AI Assistants', '4 Free Professional Bonuses Included', '7-Day Risk-Free Guarantee', '♾️ Lifetime Access & Free Updates'],
  cta: '⚡ Get the 100+ AI Prompts for Electrical Engineers™ now'
};
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit Card'
}, {
  icon: MonitorSmartphoneIcon,
  label: 'Desktop & Mobile Access'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="bg-radial-glow w-full scroll-mt-20 overflow-x-hidden" data-id="element-125" data-mp="4ruirfs5068i">
      <div className="mx-auto w-full max-w-5xl px-5 py-6" data-id="element-126" data-mp="9sry7klrim6b">
        <div className="mx-auto mb-6 max-w-md text-center" data-id="element-127" data-mp="erv57alaz2gx">
          <p className="font-display text-xl font-black text-plum" data-id="element-128" data-mp="ep8w36irkewl">🔥 Limited Offer — Ending Soon!</p>
          <p className="mt-2 text-sm font-semibold text-plum/70" data-id="element-129" data-mp="3d74g6al30n9y">
            ⚠️ After this, the price returns to $54. This rate will not come back.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center overflow-hidden rounded-3xl border border-grape/30 bg-white px-6 pb-6 text-center shadow-[0_24px_60px_-28px_rgba(0,87,255,0.5)]" data-id="element-130" data-mp="3n5k64a8dhqhv">
          <div className="-mx-6 mb-5 w-[calc(100%+3rem)] border-b-4 border-grape bg-plum px-6 py-3" data-id="element-131" data-mp="2mgqlbtkcbbq5">
            <h3 className="font-display text-base font-black text-white" data-id="element-132" data-mp="315cwdj2xphbk">{plan.name}</h3>
          </div>
          <p className="text-sm text-plum/60" data-id="element-133" data-mp="2w8w72lk00www">
            <span className="font-semibold text-plum/80" data-id="element-134" data-mp="28i0n2alsb607">Ideal for:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-135" data-mp="23ixh8nxzcvr6">
            <span className="text-[20px] font-medium text-plum/40 line-through" data-id="element-136" data-mp="23jz3lokg54o7">{plan.was}</span>
            <div className="flex w-full justify-center py-2" data-id="element-137" data-mp="2iggb24pilz5h">
              <span className="relative inline-block font-display leading-none" data-id="element-138" data-mp="2dh3f8ugo1hqr">
                <span className="absolute right-full top-1/2 mr-2 -translate-y-1/2 text-[45px] font-black leading-none text-grape" style={{
                fontFamily: "Merriweather, serif"
              }} data-id="element-139" data-mp="2dj6gkan9qxas">
                  $
                </span>
                <span className="text-grape-shine text-[74px] font-black leading-none" style={{
                fontFamily: "Merriweather, serif"
              }} data-id="element-140" data-mp="adnax2mu5m6">
                  {plan.now}
                </span>
              </span>
            </div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-141" data-mp="3nfv3y9tes9pd">
              · One-time payment · Lifetime Access ·
            </p>
            <p className="mt-1 text-center text-[11px] font-medium text-plum/55" data-id="element-142" data-mp="3rh6t6e8desx1">
              · Payment will be processed in your local currency ·
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-143" data-mp="nyn0xbpozn28">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-144" data-mp="a7i9uy0e433i">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-145" data-mp="e9n33vmxexpm" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-146" data-mp="11yg1dyr0thne">
            <CTAButton size="md" data-id="element-147" data-mp="16qpjwtpt3ffn">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[12px] font-bold text-grape" data-id="element-148" data-mp="3f7ih1xu7jeja">
            Save $147 (84% Off)
          </p>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-149" data-mp="3a7w7pzhi2ifr">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-150" data-mp="31894d857n2k2">
                <Icon className="h-4 w-4 text-grape" data-id="element-151" data-mp="1sm9j2gqdxd9" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-152" data-mp="3synd6pyd9oov">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-153" data-mp="3o6do1c52ssnn" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-154" data-mp="3k5tv6krjcb7b">
            <span className="font-display font-bold text-plum" data-id="element-155" data-mp="kjn7bn647mv8">
              🛡️ 7-Day Money-Back Guarantee.
            </span>{' '}
            If within the first 7 days you feel that this system doesn't save you at least 1 hour of
            paperwork per day, just ask for a refund. We will return 100% of your money, no questions
            asked. SIGMA SMART™ is committed to your career protection.
          </p>
        </div>
      </div>
    </section>;
}